module.exports = __webpack_public_path__ + "static/EWY_Jad_social-cover-74826260dbe982805ab59cfdf8a409a4.png";